/* Double hero spotlights: one open card at a time, clamped inside its panel. */
(function () {
  'use strict';

  var OPEN_SELECTOR = '[data-bb-spot-dot][aria-expanded="true"]';

  function cardFor(dot) {
    var layer = dot.closest('[data-bb-spotlights]');
    if (!layer) return null;
    return layer.querySelector('[data-bb-spot-card="' + dot.dataset.bbSpotDot + '"]');
  }

  function close(dot) {
    dot.setAttribute('aria-expanded', 'false');
    var card = cardFor(dot);
    if (card) {
      card.hidden = true;
      card.style.removeProperty('--bb-spot-nudge');
    }
  }

  function closeAll(scope) {
    (scope || document).querySelectorAll(OPEN_SELECTOR).forEach(close);
  }

  /* Shift the card back inside the panel when the dot sits near an edge. */
  function clamp(card, layer) {
    var isVertical =
      card.classList.contains('babybjorn-spot__card--left') ||
      card.classList.contains('babybjorn-spot__card--right');
    var bounds = layer.getBoundingClientRect();
    var rect = card.getBoundingClientRect();
    var gap = 12;
    var nudge = 0;

    if (isVertical) {
      if (rect.top < bounds.top + gap) nudge = bounds.top + gap - rect.top;
      else if (rect.bottom > bounds.bottom - gap) nudge = bounds.bottom - gap - rect.bottom;
    } else {
      if (rect.left < bounds.left + gap) nudge = bounds.left + gap - rect.left;
      else if (rect.right > bounds.right - gap) nudge = bounds.right - gap - rect.right;
    }

    if (nudge) card.style.setProperty('--bb-spot-nudge', Math.round(nudge) + 'px');
  }

  function open(dot) {
    var card = cardFor(dot);
    dot.setAttribute('aria-expanded', 'true');
    if (!card) return;
    card.hidden = false;
    card.style.removeProperty('--bb-spot-nudge');
    if (window.matchMedia('(min-width: 750px)').matches) {
      clamp(card, dot.closest('[data-bb-spotlights]'));
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-bb-spotlights]').forEach(function (layer) {
      if (layer.dataset.bbSpotlightsBound === '1') return;
      layer.dataset.bbSpotlightsBound = '1';

      layer.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-bb-spot-dot]');
        if (!dot) return;
        event.stopPropagation();
        var wasOpen = dot.getAttribute('aria-expanded') === 'true';
        closeAll();
        if (!wasOpen) open(dot);
      });
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-bb-spotlights]')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
